import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from "../../context/AuthContext";
import { account, storage } from "../../appwrite/config";
import AlertMessage from "../include/AlertMessage";
import ConfirmationPopup from "../include/ConfirmationPopup"; // ⬅️ Import new popup
import Pagination from '../Pagination';

var _ = require('lodash');

function Coupons() {
  const [allagents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const token = sessionStorage.getItem('JWT_TOKEN');
  const [alert, setAlert] = useState({ type: "", message: "" });
  const [showPopup, setShowPopup] = useState(false); // popup state
  const [deleteId, setDeleteId] = useState(null); // store user id for delete
  const [deleting, setDeleting] = useState(false);

  const { role, user } = useAuth();
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = Number(searchParams.get("page")) || 1;
  const LIMIT = 10;

  const fetchAgents = async (page = currentPage) => {
    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/agents`, {
        params: {
          userId: role === "admin" ? null : user?.$id, // Pass user ID for non-admins
          page,
          limit: LIMIT
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token // Replace with your token
        }
      });
      if (Array.isArray(response.data.data) && response.data.data.length > 0) {
        const responseData = response.data.data;
        setData(responseData);

        setTotalPages(response.data.pagination.totalPages);
        setTotalRecords(response.data.pagination.total);
      } else {
        setData([]);
      }
    } catch (err) {
      const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
      setAlert({ type: "error", message: apierror });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.documentElement.className = "";

    fetchAgents(currentPage);
  }, [currentPage]);

  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      setDeleting(true);
      const response = await axios.delete(`${process.env.REACT_APP_API_URL}/deletecoupon/${deleteId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token // Replace with your token
          }
        }
      );

      if (response.status === 200 || response.status === 201) {
        const updatedData = data.filter(coupon => coupon.$id !== deleteId);

        setData(updatedData);

        setAlert({ type: "success", message: "coupon deleted successfully!" });

        // ⭐ If page becomes empty go to previous page
        if (updatedData.length === 0 && currentPage > 1) {
          setSearchParams({
            page: currentPage - 1
          });
        }
      }
      //fetchCoupons();
    } catch (err) {
      const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
      setAlert({ type: "error", message: apierror });
    } finally {
      setShowPopup(false); // close popup after action
      setDeleteId(null); // reset id
      setDeleting(false);
    }
  };

  return (
    <section>
      <div className="is-title-bar">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
          <ul>
            <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
            <li>Agents</li>
          </ul>
          {["admin", "agent", "organization"].includes(role) && (
          <Link to="/agent/add" className='button blue'>Add Agent</Link>
          )}
        </div>
      </div>
      <div className="section main-section">
        <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
          <div className="card">
            <header className="card-header">
              <p className="card-header-title">
                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                Agents
              </p>
            </header>
            <div className="card-content">
              {alert.message && (
                <AlertMessage
                  type={alert.type}
                  message={alert.message}
                  onClose={() => setAlert({ type: "", message: "" })}
                  duration={3000}
                />
              )}
              {loading ? (
                <div className="flex justify-center items-center py-10">
                  <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                </div>

              ) : (
                Array.isArray(data) && data.length > 0 ? (
                  <>
                    <table>
                      <thead>
                        <tr>
                          <th>Artist</th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {(data || []).map((item, index) => (
                          <tr key={item.$id}>
                            <td data-label="Artist"></td>
                            <td data-label={item.firstName}>{item.firstName}</td>
                            <td data-label={item.lastName}>{item.lastName}</td>
                            <td className="actions-cell">
                              <div className="buttons right nowrap">
                                {["admin", "agent", "organization"].includes(role) && (
                                  <Link to={`/agent/edit/${item.$id}?page=${currentPage}`} className='button small green'> <span className="icon"><i className="mdi mdi-lead-pencil"></i></span></Link>
                                )}
                                {["admin", "agent", "organization"].includes(role) && (
                                  <button
                                    className="button small red"
                                    type="button"
                                    onClick={() => {
                                      if (deleting) return;
                                      setDeleteId(item.$id);
                                      setShowPopup(true);
                                    }}
                                    style={{
                                      cursor: deleting ? "not-allowed" : "pointer",
                                      opacity: deleting ? 0.5 : 1
                                    }}
                                  >
                                    <span className="icon"><i className="mdi mdi-trash-can"></i></span>
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    {totalPages > 1 && (
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        totalRecords={totalRecords}
                        onPageChange={(page) =>
                          setSearchParams({
                            page
                          })
                        }
                      />
                    )}
                  </>
                ) : (
                  <p style={{ color: 'red', fontWeight: 'bold', textAlign: 'center' }}>No Record Found.</p>
                )
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Confirmation Popup */}
      <ConfirmationPopup
        show={showPopup}
        onConfirm={handleDelete}
        onCancel={() => {
          if (!deleting) {
            setShowPopup(false);
          }
        }}
        title="Confirm Delete"
        message={
          deleting
            ? "Deleting coupon..."
            : "Are you sure you want to delete this coupon?"
        }
        deleting={deleting}
      />
    </section>
  );
};

export default Coupons;
